import { ChangeEvent, useEffect, useState } from "react";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import ContainerComponent from "../../components/conatiner";
import HeaderComponent from "../../components/header";
import InputComponent from "../../components/input";
import TableComponent from "../../components/table";
import { IState } from "../../types";
import { StatesCreateService, StatesDeleteService, StatesService } from "../../services/states";
import { ToastErro, ToastSucesso } from "../../components/toast";
import ModalComponent from "../../components/modal";

const StatesPage = () => {

    const [loading, setLoading] = useState<boolean>(true);

    const [states, setStates] = useState<any>([]);

    // variaveis de pesquisa
    const [search, setSearch] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // variaveis de cadastro
    const [createDescription, setCreateDescription] = useState<string>('');
    const [createUF, setCreateUF] = useState<string>('');
    // variaveis de cadastro

    // função para pesquisar estados
    const getStates = async () => {

        setLoading(true);

        await StatesService(search, page).then(resp => {
            setStates(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar estados

    // função para cadastrar estado
    const createState = async () => {

        if (createDescription.length < 1 || createUF.length < 1) {
            ToastErro('Preencha todos os campos!');
            return;
        }

        (window as any).$("#modalCreate").modal('hide');

        setLoading(true);

        await StatesCreateService(createDescription, createUF).then(resp => {
            setCreateDescription('');
            setCreateUF('');
            ToastSucesso(resp.data.message);
            getStates();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
            (window as any).$("#modalCreate").modal('show');
        })

    }
    // função para cadastrar estado

    // função para desativar/ativar estado
    const disableState = async (id: number) => {

        (window as any).$("#modalDisabled" + id).modal('hide');

        setLoading(true);

        await StatesDeleteService(id).then(resp => {
            ToastSucesso(resp.data.message);
            getStates();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para desativar/ativar estado

    useEffect(() => {
        getStates();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Estados"
                button="Estado"
                iconButton="add"
                onClick={() => (window as any).$("#modalCreate").modal('show')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="Pesquisar"
                                col={8}
                                defaultValue={search}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
                                size={"small"}
                            />
                            <div className="col-md-4">
                                <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getStates()}>Pesquisar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Estados"
                        columns={['ID', 'Estado', 'Sigla', 'Ativo', 'Ações']}
                        loading={loading}
                        last_page={states?.last_page}
                        page={page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            states?.data?.map((s: IState) => {
                                return (
                                    <tr key={s.id}>
                                        <td className="px-4">{s.id}</td>
                                        <td className="px-4">{s.description}</td>
                                        <td className="px-4">{s.uf}</td>
                                        <td className="px-4">
                                            {
                                                s.active == 1

                                                    ?

                                                    <h5><span className="badge bg-success">Sim</span></h5>

                                                    :

                                                    <h5><span className="badge bg-danger">Não</span></h5>
                                            }
                                        </td>
                                        <td className="px-4">
                                            {/* <button className="btn btn-text-warning" type="button" title="Editar"><i className="material-icons">edit</i></button>
                                            <ModalComponent
                                                title="Editar Estado"
                                                id={`modalUpdate${s.id}`}
                                            >
                                                <>
                                                
                                                </>
                                            </ModalComponent> */}
                                            <button className="btn btn-text-danger" type="button" title={s.active == 1 ? 'Desativar' : 'Ativar'} onClick={() => (window as any).$(`#modalDisabled${s.id}`).modal('show')}><i className="material-icons">{s.active == 1 ? 'delete' : 'upload'}</i></button>

                                            <ModalComponent
                                                title={s.active == 1 ? 'Desativar Estado' : 'Ativar Estado'}
                                                id={`modalDisabled${s.id}`}
                                            >
                                                <>
                                                    <p>Você tem certeza que deseja {s.active == 1 ? 'desativar' : 'ativar'} o estado abaixo?</p>
                                                    <table className="table mt-4">
                                                        <tbody>
                                                            <tr>
                                                                <td>Estado:</td>
                                                                <td>{s.description}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Sigla:</td>
                                                                <td>{s.uf}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => disableState(s.id)}>{s.active == 1 ? 'Desativar' : 'Ativar'}</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>

                    <ModalComponent
                        title="Cadastrar Estado"
                        id="modalCreate"
                    >
                        <>
                            <div className="row mt-3">
                                <InputComponent
                                    label="Estado"
                                    col={12}
                                    defaultValue={createDescription}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCreateDescription(e.target.value)}
                                />
                            </div>
                            <div className="row">
                                <InputComponent
                                    label="Sigla"
                                    col={12}
                                    defaultValue={createUF}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setCreateUF(e.target.value)}
                                />
                            </div>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="button" onClick={createState}>Cadastrar</button>
                            </div>
                        </>
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default StatesPage;